export default __webpack_public_path__ + "static/media/caret-down.7bcf2734.svg";